module.exports = __webpack_public_path__ + "img/blue2.590089ac.png";